(function($){

$(document).ready(function() {

	var isHome = $('body').hasClass('home'),
		isMobile = 'ontouchstart' in window;
	
	if ( isMobile ) $('body').addClass('isTouch');
	
	// Contact link
	$('.contact-popup').click(function(e){
		e.preventDefault();
		$('#popup-contact-form').foundation('toggle');
		return false;
	});
	
	// WooCommerce Mini Cart
	$('.minicart_toggle').click(function(e){ 
		e.stopPropagation();
		$(this).toggleClass('open');
//		$('.minicart_container').toggle();
	} );
	$('.minicart_container').click(function(e){e.stopPropagation(); });
	$(document).click(function() { jQuery('.minicart_toggle').removeClass('open'); } );
	
	
	// Footer
	$('footer.footer').addClass('absolute')
	
	// Resize
	$(window).resize(function(event) {
		// Footer
		$('.off-canvas-content').css('padding-bottom', $('footer.footer').outerHeight() + 'px');

	}).resize();
	
	// WooCommerce add to cart
	$(document).on( 'added_to_cart' , function () {
		var q = 0;
		$('.mini_cart_item .quantity').each(function() {
		 	var n = this.childNodes[0].nodeValue.match(/\d+/)[0]; 
		 	q += +n;
		});
	});

});

})(jQuery)